import { Directive, Input, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[equalTo]',
    providers: [{ provide: NG_VALIDATORS, useExisting: EqualToValidatorDirective, multi: true }],
    standalone: false,
})
export class EqualToValidatorDirective implements Validator, OnChanges {
    @Input() equalTo: string;
    private currentValue: string;
    private _control: AbstractControl;

    ngOnChanges(changes: SimpleChanges): void {
        const change: SimpleChange = changes['equalTo'];
        if (change) {
            this.currentValue = change.currentValue;
            if (this._control) this._control.setValue(this._control.value, { emitEvent: true });
        }
    }

    validate(control: AbstractControl): { equalTo: boolean } {
        this._control = control;
        if (control.value !== this.currentValue) return { equalTo: true };

        return null;
    }
}
